export const DEFAULT_HEARTBEAT_ENDPOINT = '/gateway/api/session/heartbeat';
export const DEFAULT_IDLE_TIME = 60000;
export const INTERVAL_TIME = 10000;